import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { TextField } from "@mui/material";
import { MRT_Row, MRT_RowData } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
type CustomCantidadRecibidaInputProps<T extends MRT_RowData> = {
  row: MRT_Row<T>
  value: string | number
  handleValue: (value: number) => void;
  maxValue: number
}

const CustomCantidadRecibidaInput = <T extends MRT_RowData>({
  //row,
  value,
  handleValue,
  maxValue
}: CustomCantidadRecibidaInputProps<T>) => {
  const setAlert = useUiStore(s => s.setAlert)
  const handleKeyDown = useMemo<React.KeyboardEventHandler<HTMLDivElement> | undefined>(() => (event) => {
    if (['e', 'E', '-', '.', ','].includes(event.key)) {
      event.preventDefault();
    }
  }, []);
  const [inputValue, setInputValue] = useState(value === 0 ? "0" : (value.toString()));
  
  useEffect(() => {
    setInputValue(value.toString());
  }, [value, maxValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let newvalue = e.target.value.trim()

    if (newvalue === "") {
      setInputValue('0')
      handleValue(0);
      return
    }
    if(newvalue.startsWith("0") && newvalue.length > 1){
      newvalue = newvalue.replace(/^0+/, "");
    }
    /* if (inputValue === "0" && newvalue !== "0") {
      const cleanedValue = newvalue.replace(/^0+/, "");
      setInputValue(newvalue.replace(/^0+/, ""));
      handleValue(Number(cleanedValue));
      return
    } */
    // Convertir el valor a número
    const numericValue = parseFloat(newvalue);
   

    // Si es un número válido, actualizar el estado y pasar el valor a handleValue
    if (!isNaN(numericValue)) {
      if (numericValue > maxValue) {
        setAlert(true, `No puedes exceder la cantidad máxima permitida de ${maxValue}.`, AlertSeverityEnum.info)
        setInputValue(maxValue.toString()); // Mantener como cadena para el input
        handleValue(maxValue); // Pasar el valor como número

      } else {
        setInputValue(newvalue); // Mantener como cadena para el input
        handleValue(numericValue); // Pasar el valor como número
      }

    } else {
      setInputValue("0"); // Si no es un número válido, mostrar "0"
      handleValue(0); // Enviar 0
    }


  }

  return (
    <TextField
      type="number"
      size="small"
      variant="outlined"
      inputProps={{ min: 0, max: maxValue, step: 1 }}
      aria-label="Cantidad del producto"
      value={inputValue}
      onKeyDown={handleKeyDown}
      onChange={handleChange}

    />

  )
}
export default CustomCantidadRecibidaInput;